import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// import TestIndex from '../components/index.vue';

const routes = [

  { path: '*', redirect: '/home' }, // 重定向
  // { path: '/', redirect: '/home' }, // 重定向到登录页
  {
    path: '/login',
    name: 'login',
    component: () => import('@/components/loginIndex.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/components/qhdIndex.vue'),
    // children: [
    //   {
    //     path: '/login',
    //     name: 'login',
    //     component: () => import('@/components/loginIndex.vue')
    //   },
    //   {
    //     path: 'my',
    //     name: 'my',
    //     component: () => import('@/components/MyCom.vue')
    //   }
    // ]
  },
];


const router = new VueRouter({
  mode: 'history',
  routes
});


export default router;